
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.912 14.332c-.283-.282-.136-.203-.818-.385a2.348 2.348 0 01-.828-.434l-1.477 3.621a.52.52 0 00.502.717l1.716-.065 1.18 1.246a.52.52 0 00.86-.162l1.694-4.154a2.362 2.362 0 01-1.15.312 2.361 2.361 0 01-1.68-.696zm9.299 2.802l-1.477-3.62c-.246.19-.518.35-.828.433-.686.183-.535.103-.817.386a2.362 2.362 0 01-1.68.695c-.406 0-.797-.116-1.15-.312l1.694 4.155c.143.35.6.436.86.161l1.18-1.246 1.716.065a.52.52 0 00.502-.717zm-3.9-3.538c.498-.506.555-.463 1.263-.656.452-.123.806-.483.927-.943.243-.925.18-.813.844-1.49a1.35 1.35 0 00.34-1.288c-.244-.924-.244-.795 0-1.72a1.35 1.35 0 00-.34-1.288c-.664-.676-.6-.565-.844-1.49a1.323 1.323 0 00-.927-.943c-.908-.247-.798-.183-1.463-.86a1.295 1.295 0 00-1.266-.345c-.907.248-.78.248-1.69 0a1.294 1.294 0 00-1.266.346c-.664.676-.555.612-1.463.86a1.323 1.323 0 00-.926.943c-.243.924-.18.813-.845 1.489a1.35 1.35 0 00-.34 1.288c.244.924.244.795 0 1.72-.12.46.009.951.34 1.289.664.676.601.564.845 1.489.12.46.474.82.926.943.729.199.783.168 1.263.656.43.438 1.101.517 1.619.19a1.291 1.291 0 011.385 0 1.293 1.293 0 001.618-.19zM6.93 8.256C6.93 6.53 8.304 5.13 10 5.13c1.696 0 3.071 1.4 3.071 3.126s-1.375 3.126-3.07 3.126c-1.697 0-3.072-1.4-3.072-3.126z","fill":"#545F7C"}})])
          )
        }
      }
    